import { ChartDonut } from 'components/chart'
import { useTranslations } from 'hooks'
import React from 'react'
import { StepperLabelType } from './StepperLabelHorizontal'

/** Render a top label for step */
export const StepperLabelVertical: React.FC<StepperLabelType> = ({ steps, stepIndex, onClick }: StepperLabelType) => {

    const [
        YOU_ARE_ON_STEP
    ] = useTranslations(i18n)

    return (
        <div className="step-label step-label-vertical">
            {
                steps.map((step, index) => (
                    <div 
                        className={`step-label-item ${step.labelClass} ${index <= stepIndex && 'active'} ${index === stepIndex && 'active-index'}`} 
                        key={index}
                        onClick={() => onClick?.(step, index)}>
                        <div 
                            className="step-label-image"
                            style={{backgroundImage: `url(${step.img})`}}>
                            <span className="badge"></span>
                        </div>
                        <h1>
                            {index + 1}. {step.title}
                        </h1>
    
                        {
                            index  < steps.length - 1 && 
                            <div className="step-label-dots">
                                <span className="badge"></span>
                                <span className="badge"></span>
                                <span className="badge"></span>
                            </div>
                        }
                    </div>
                ))
            }
    
            <ChartDonut
                value={((stepIndex + 1) * 100 / steps.length)}
                label={(
                    <>
                    <h3><span id={"sdsCreationStepProgressChartDonut"}>{`${((stepIndex + 1) * 100 / steps.length).toFixed(0)}`}</span> %</h3>
                        <p>{YOU_ARE_ON_STEP} {stepIndex + 1}</p>
                    </>
                )}
                />
        </div>
    )
}

const i18n = [
    'SDS1Click.SDS.StepperIndication.CurrentStep.label'
]
